export default function contentLoad() {
	return (dispatch) => {
		dispatch({
			type: 'CONTENT_LOAD',
		});
	};
}